module.exports = __webpack_public_path__ + "img/banner-planet.c6abe34f.png";